define('modules/common/service/Token',[], function() {
	var Token = function() {
		return {
			set: function(token) {
				sessionStorage.setItem('TOKEN', token);
				return token;
			},
			isset: function() {
				return !!sessionStorage.getItem('TOKEN');
			},
			reset: function() {
				sessionStorage.setItem('TOKEN', '');
			},
			get: function() {
				return sessionStorage.getItem('TOKEN');
			}
		};
	};

	return [Token];
});
